import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationServices } from '../../../../appauth/notification/notificatio.services';
import { CustomValidators } from 'ng2-validation';
import { Gastos } from '../../gasto/gastos.model';
import { GastosServices } from '../../gasto/gastos.services';

@Component({
	selector: 'app-addgasto',
	templateUrl: './addgasto.component.html',
	styleUrls: ['./addgasto.component.scss']
})

export class AddGastoComponent implements OnInit {
	public formAddGasto: FormGroup;

	constructor(private fb: FormBuilder,
		private activeModal:NgbActiveModal,
		private servicioGasto:GastosServices,
		private Noti:NotificationServices,) { }

	ngOnInit() {
		this.formAddGasto = this.fb.group({
			motivo:[null,Validators.compose([Validators.required,Validators.minLength(1), Validators.maxLength(500)])],
			tipo:[1,Validators.compose([Validators.required,CustomValidators.number])],
			estado:[1,null],
		});
	}


	save(){
		let gastoDataModel:Gastos=this.formAddGasto.value;
		this.servicioGasto.saveGastos(gastoDataModel).subscribe((data:any)=>{
			if(data.estado){
				this.Noti.setNotification(data).then((datas)=>{
					if(datas){
						this.activeModal.close(1);
					}
				});
			}else{
				this.Noti.setNotification(data);
			}
		});
	}

	cerrarModal(){
		this.activeModal.close(2);
	}
}